/* eslint-disable */
export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // Form menu
    $(".open-form").each(function () {
      $(this).click(function (e) {
        e.preventDefault();
        if (!$("#contact-form").hasClass("opened")) {
          $("#contact-form").addClass("opened");
          $("#bg-contact").addClass("opened");
          $("body").addClass("no-scroll");
        }
      });
    });

    $(".open-calendly").each(function () {
      $(this).click(function (e) {
        e.preventDefault();
        if (!$("#calendly-form").hasClass("opened")) {
          $("#calendly-form").addClass("opened");
          $("#bg-contact").addClass("opened");
          $("body").addClass("no-scroll");
        }
      });
    });

    $(".close-form, #bg-contact").each(function () {
      $(this).click(function () {
        if ($("#contact-form, #calendly-form").hasClass("opened")) {
          $("#contact-form, #calendly-form").removeClass("opened");
          $("#contact-form, #calendly-form").removeClass("success");
          $("#bg-contact").removeClass("opened");
          $("body").removeClass("no-scroll");
        }
      });
    });

    $(".form-field").each(function () {
      $(this).focus(function () {
        $(".form-field").each(function () {
          if (!$.trim(this.value).length) {
            $(this).closest(".form-group").removeClass("focus");
            $(this).closest(".login-username").removeClass("focus");
            $(this).closest(".login-password").removeClass("focus");
          }
        });
        $(this).closest(".form-group").addClass("focus");
        $(this).closest(".login-username").addClass("focus");
        $(this).closest(".login-password").addClass("focus");
      });
    });

    $("input").each(function () {
      $(this).focus(function () {
        $("input").each(function () {
          if (!$.trim(this.value).length) {
            $(this).closest(".login-username").removeClass("focus");
            $(this).closest(".login-password").removeClass("focus");
          }
        });
        $(this).closest(".login-username").addClass("focus");
        $(this).closest(".login-password").addClass("focus");
      });
    });

    $(".support-button").each(function () {
      $(this).click(function () {
        if (!$(".support-modal").hasClass("open")) {
          $(".support-modal").addClass("open");
        }
      });
    });

    $(".support-modal .bg").each(function () {
      $(this).click(function () {
        if ($(".support-modal").hasClass("open")) {
          $(".support-modal").removeClass("open");
        }
      });
    });

    $("#lostpasswordform").submit(function (evt) {
      evt.preventDefault();
      $.ajax({
        url: jsinfo_website.ajaxurl,
        method: "POST",
        dataType: "json",
        data:
          "action=lostPassword&" +
          $("#lostpasswordform").serialize() +
          "&security=" +
          jsinfo_website.ajax_nonce,
      }).done(function (data) {
        if (typeof data.result != "undefined") {
          if (data.result == "1") {
            alert(
              "Un lien de réinitialisation du mot de passe vous a été envoyé par email"
            );
          } else {
            alert("Désolé mais cette adresse email n'est pas reconnue.");
          }
        }
      });
      return false;
    });

    const forms = [
      { form: '#contact-form', successClass: 'success', invalidClass: 'invalid' },
      { form: '#register-webinar', successClass: 'success', invalidClass: 'invalid' }
    ];

    forms.forEach(({ form, successClass, invalidClass }) => {
      const formElement = document.querySelector(`${form} .wpcf7`);
      formElement.addEventListener(
      "wpcf7mailsent",
      () => $(form).addClass(successClass),
      false
      );
      formElement.addEventListener(
      "wpcf7invalid",
      () => $(form).addClass(invalidClass),
      false
      );
    });

    $(window).scroll(function () {
      let windowBottom = $(window).scrollTop() + $(window).innerHeight();
      $("#arrow-icon").each(function () {
        let bottom = $(this).offset().top + $(this).outerHeight();
        bottom += 200;
        if (bottom < windowBottom && !$(this).hasClass("active")) {
          $(this).html(
            '<svg id="eQ5SlXmtnys1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 92 101" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><style><![CDATA[#eQ5SlXmtnys3 {animation: eQ5SlXmtnys3_c_o 6000ms linear 1 normal forwards}@keyframes eQ5SlXmtnys3_c_o { 0% {opacity: 1;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 16.666667% {opacity: 0.5;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 33.333333% {opacity: 1} 50% {opacity: 0.5;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 66.666667% {opacity: 1} 83.333333% {opacity: 0.5;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {opacity: 1}} #eQ5SlXmtnys5_to {animation: eQ5SlXmtnys5_to__to 6000ms linear 1 normal forwards}@keyframes eQ5SlXmtnys5_to__to { 0% {transform: translate(35.599998px,44.949999px);animation-timing-function: cubic-bezier(0.455,0.03,0.515,0.955)} 15% {transform: translate(33.599998px,42.949999px);animation-timing-function: cubic-bezier(0.455,0.03,0.515,0.955)} 18.333333% {transform: translate(33.599998px,42.949999px);animation-timing-function: cubic-bezier(0.455,0.03,0.515,0.955)} 33.333333% {transform: translate(35.599998px,44.949999px)} 48.333333% {transform: translate(33.599998px,42.949999px);animation-timing-function: cubic-bezier(0.455,0.03,0.515,0.955)} 51.666667% {transform: translate(33.599998px,42.949999px);animation-timing-function: cubic-bezier(0.455,0.03,0.515,0.955)} 66.666667% {transform: translate(35.599998px,44.949999px)} 81.666667% {transform: translate(33.599998px,42.949999px);animation-timing-function: cubic-bezier(0.455,0.03,0.515,0.955)} 85% {transform: translate(33.599998px,42.949999px);animation-timing-function: cubic-bezier(0.455,0.03,0.515,0.955)} 100% {transform: translate(35.599998px,44.949999px)}} #eQ5SlXmtnys5 {animation: eQ5SlXmtnys5_c_o 6000ms linear 1 normal forwards}@keyframes eQ5SlXmtnys5_c_o { 0% {opacity: 1;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 3.333333% {opacity: 1;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 15% {opacity: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 18.333333% {opacity: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 30% {opacity: 1;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 33.333333% {opacity: 1} 36.666667% {opacity: 1;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 48.333333% {opacity: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 51.666667% {opacity: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 63.333333% {opacity: 1;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 66.666667% {opacity: 1} 70% {opacity: 1;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 81.666667% {opacity: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 85% {opacity: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 96.666667% {opacity: 1;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {opacity: 1}} #eQ5SlXmtnys7 {animation: eQ5SlXmtnys7_s_do 6000ms linear 1 normal forwards}@keyframes eQ5SlXmtnys7_s_do { 0% {stroke-dashoffset: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 15% {stroke-dashoffset: 8.17435;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 18.333333% {stroke-dashoffset: 8.17435;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 33.333333% {stroke-dashoffset: 0} 48.333333% {stroke-dashoffset: 8.17435;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 51.666667% {stroke-dashoffset: 8.17435;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 66.666667% {stroke-dashoffset: 0} 81.666667% {stroke-dashoffset: 8.17435;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 85% {stroke-dashoffset: 8.17435;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {stroke-dashoffset: 0}} #eQ5SlXmtnys8 {animation: eQ5SlXmtnys8_s_do 6000ms linear 1 normal forwards}@keyframes eQ5SlXmtnys8_s_do { 0% {stroke-dashoffset: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 15% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 18.333333% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 33.333333% {stroke-dashoffset: 0} 48.333333% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 51.666667% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 66.666667% {stroke-dashoffset: 0} 81.666667% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 85% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {stroke-dashoffset: 0}} #eQ5SlXmtnys9 {animation: eQ5SlXmtnys9_s_do 6000ms linear 1 normal forwards}@keyframes eQ5SlXmtnys9_s_do { 0% {stroke-dashoffset: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 15% {stroke-dashoffset: 12.16;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 18.333333% {stroke-dashoffset: 12.16;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 33.333333% {stroke-dashoffset: 0} 48.333333% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 51.666667% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 66.666667% {stroke-dashoffset: 0} 81.666667% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 85% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {stroke-dashoffset: 0}} #eQ5SlXmtnys10 {animation: eQ5SlXmtnys10_s_do 6000ms linear 1 normal forwards}@keyframes eQ5SlXmtnys10_s_do { 0% {stroke-dashoffset: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 15% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 18.333333% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 33.333333% {stroke-dashoffset: 0} 48.333333% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 51.666667% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 66.666667% {stroke-dashoffset: 0} 81.666667% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 85% {stroke-dashoffset: 12.23;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {stroke-dashoffset: 0}} #eQ5SlXmtnys11 {animation: eQ5SlXmtnys11_s_do 6000ms linear 1 normal forwards}@keyframes eQ5SlXmtnys11_s_do { 0% {stroke-dashoffset: 0;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 15% {stroke-dashoffset: 8.08;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 18.333333% {stroke-dashoffset: 8.08;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 33.333333% {stroke-dashoffset: 0} 48.333333% {stroke-dashoffset: 8.08;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 51.666667% {stroke-dashoffset: 8.08;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 66.666667% {stroke-dashoffset: 0} 81.666667% {stroke-dashoffset: 8.08;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 85% {stroke-dashoffset: 8.08;animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 100% {stroke-dashoffset: 0}}]]></style><g><path id="eQ5SlXmtnys3" d="M52.6,11L73,69.1L14.8,48.8L30.7,38.5L3.8,11.6L15.5,0L42.3,26.8L52.6,11Z" fill="#4348fe"/></g><g><g id="eQ5SlXmtnys5_to" transform="translate(35.599998,44.949999)"><path id="eQ5SlXmtnys5" d="M49.8,21.4L70.2,79.5L12,59.2L27.9,48.9L1,22L12.6,10.4L39.4,37.2L49.8,21.4Z" transform="translate(-35.599998,-44.949999)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></g></g><g transform="translate(.000001 0)"><path id="eQ5SlXmtnys7" d="M57.1,83l-7.9,2.1" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="8,17"/><path id="eQ5SlXmtnys8" d="M67.7,88.6l-3.2,11.8" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="12.23"/><path id="eQ5SlXmtnys9" d="M76.8,86.2l8.6,8.6" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="12,16"/><path id="eQ5SlXmtnys10" d="M79.2,77.1L91,73.9" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="12.23"/><path id="eQ5SlXmtnys11" d="M73.6,66.4l2.1-7.8" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="8.08"/></g></svg>'
          );
          $(this).addClass("active");
        }
      });
    });

    // Post Applicatifs - slider videos list //
    let slideIndex = 1;
    let slides = document.querySelectorAll(".feature-slide");
    if (typeof slides != "undefined" && slides != null) {
      showSlides(slideIndex);
    }

    let slidesNav = document.querySelectorAll(".nav-slide");
    if (typeof slidesNav != "undefined" && slidesNav != null) {
      slidesNav.forEach((slide) => {
        slide.addEventListener("click", function () {
          showSlides((slideIndex = slide.dataset.slide));
          if (window.outerWidth < 768) {
            document.getElementById("videos").scrollIntoView();
          }
        });
      });
    }

    function showSlides(n) {
      let i;
      let slides = document.querySelectorAll(".feature-slide");
      if (typeof slides != "undefined" && slides != null) {
        if (n > slides.length) {
          slideIndex = 1;
        }
        if (n < 1) {
          slideIndex = slides.length;
        }
        for (i = 0; i < slides.length; i++) {
          slides[i].classList.remove("active");
          slides[slideIndex - 1].classList.remove("play-video");
        }
        if (slides[slideIndex - 1]) {
          slides[slideIndex - 1].classList.add("active");
          if (slides[slideIndex - 1].classList.contains("active")) {
            slides[slideIndex - 1].addEventListener("click", function (e) {
              slides[slideIndex - 1].classList.add("play-video");
            });
          }
        }
        $(".feature-slide:not(.active) iframe").each(function () {
          var el_src = $(this).attr("src");
          $(this).attr("src", el_src);
        });
      }
    }

    var slideFeat = document.querySelector(
      ".group-videos-list .video-slider__feature .feature-slide"
    );
    var slideFeatDesc = document.querySelector(
      ".group-videos-list .video-slider__feature .feature-slide .content__text div"
    );
    if (typeof slideFeat != "undefined" && slideFeat != null) {
      if (!slideFeatDesc) {
        var slideNav = document.querySelector(
          ".group-videos-list .video-slider__nav"
        );
        if (window.outerWidth < 768) {
          slideNav.style.marginTop = "100px";
        } /* else if (window.outerWidth > 768) {
          slideNav.style.marginTop = "0";
        } */
      }
    }

    // Menu ancres applicatifs
    var listAnchors = document.querySelectorAll(
      ".applicatifs-template-default .applicatif-menu__submenu"
    );
    if (typeof listAnchors != "undefined" && listAnchors != null) {
      listAnchors.forEach((anchor) => {
        anchor.addEventListener("click", function (e) {
          var current = e.target.closest(
            ".applicatifs-template-default .applicatif-menu__submenu"
          );
          listAnchors.forEach((e) => {
            if (e !== current) {
              e.classList.remove("active");
            }
          });
          e.preventDefault();
          console.log(e.target.getAttribute("href"));
          e.target.classList.add("active");
          const yOffset = -250;
          const element = document.querySelector(this.getAttribute("href"));
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
          /* document.querySelector(this.getAttribute("href")).scrollIntoView({
            behavior: "smooth",
          }); */
        });
      });
    }
    document.addEventListener("scroll", function () {
      document
        .querySelectorAll(".applicatif-menu-mobile .applicatif-menu__submenu")
        .forEach(function (item) {
          var itemId = item.getAttribute("href");

          var itemSelected = document.querySelector(itemId);

          if (
            window.scrollY > itemSelected.offsetTop &&
            itemSelected.offsetTop + itemSelected.offsetHeight > window.scrollY
          ) {
            document
              .querySelectorAll(
                ".applicatif-menu-mobile .applicatif-menu__submenu"
              )
              .forEach((element) => {
                element.classList.remove("active");
              });
            var currentItem = document.querySelector(
              '.applicatif-menu-mobile a[href="' + itemId + '"]'
            );

            currentItem.classList.add("active");
            var notCurrentItem = item.getAttribute("href");

            /* if (notCurrentItem !== itemId) {
              if (item.classList.contains("active")) {
                item.classList.remove("active");
              }
            } */
          }
        });
      document
        .querySelectorAll(".applicatif-menu-desktop .applicatif-menu__submenu")
        .forEach(function (item) {
          var itemId = item.getAttribute("href");

          var itemSelected = document.querySelector(itemId);

          if (
            window.scrollY > itemSelected.offsetTop &&
            itemSelected.offsetTop + itemSelected.offsetHeight > window.scrollY
          ) {
            document
              .querySelectorAll(
                ".applicatif-menu-desktop .applicatif-menu__submenu"
              )
              .forEach((element) => {
                element.classList.remove("active");
              });
            var currentItem = document.querySelector(
              '.applicatif-menu-desktop a[href="' + itemId + '"]'
            );
            currentItem.classList.add("active");
            var notCurrentItem = item.getAttribute("href");
            /* if (notCurrentItem !== itemId) {
              if (item.classList.contains("active")) {
                item.classList.remove("active");
              }
            } */
          }
        });
    });

    // Menu applicatifs
    var menuApplicatif = document.querySelectorAll(".applicatifs-megamenu");
    var overlayApplicatif = document.querySelector(".menu-applicatifs");
    if (typeof menuApplicatif != "undefined" && menuApplicatif != null) {
      menuApplicatif.forEach((menu) => {
        menu.addEventListener("click", function (e) {
          e.preventDefault();
          overlayApplicatif.classList.toggle("active");
          document.querySelector("body").classList.toggle("megamenu-active");
          menu.classList.toggle("close");
          menu.classList.add("active");
          if ($(window).width() > 767) {
            overlayApplicatif.classList.add("active");
            document.querySelector("body").classList.add("megamenu-active");
            document.querySelector(".menu-applicatifs__close").style.display =
              "block";
          }
          if (overlayApplicatif.classList.contains("active")) {
            document.querySelector("body").style.overflow = "hidden";
            document.querySelector("header .brand").style.visibility = "hidden";
          } else {
            document.querySelector("body").style.overflow = "auto";
            document.querySelector("header .brand").style.visibility =
              "visible";
          }
        });
      });
    }
    var closeApplicatif = document.querySelector(".menu-applicatifs__close");
    closeApplicatif.addEventListener("click", function () {
      closeApplicatif.style.display = "none";
      overlayApplicatif.classList.remove("active");
      menuApplicatif.forEach((menu) => {
        menu.classList.remove("active");
      });
      document.querySelector("body").style.overflow = "auto";
      document.querySelector("header .brand").style.visibility = "visible";
      document.querySelector("body").classList.remove("megamenu-active");
    });

    // Applicatif partie Tarifs / Onglets
    var tabTitle = document.querySelectorAll(".tab-title");
    var tabCards = document.querySelectorAll(".single-tab-cards");
    if (
      typeof tabTitle[0] != "undefined" &&
      tabTitle != null &&
      typeof tabCards[0] != "undefined" &&
      tabCards != null
    ) {
      tabTitle[0].classList.add("active");
      tabCards[0].classList.remove("not-active");

      tabTitle.forEach((title) => {
        title.addEventListener("click", (e) => {
          var current = e.target.closest(".tab-title");

          var tabButton = current.dataset.button;

          tabCards.forEach((card) => {
            card.classList.add("not-active");
            var tab = card.dataset.tab;
            if (tabButton == tab) {
              card.classList.remove("not-active");
            }
          });

          tabTitle.forEach((element) => {
            if (element !== current) {
              element.classList.remove("active");
            }
          });
          current.classList.add("active");
        });
      });
    }

    // Lightbox
    $(".group-content-img .small-img").each(function () {
      $(this).click(function () {
        let img = $(this).attr("data-image");
        console.log(img);
        $("#lightbox img").attr("src", img);
        $("#lightbox").fadeIn("slow").css("display", "flex");
      });
    });

    $("#lightbox").click(function () {
      $(this).fadeOut("fast");
    });
  },
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/common.js